/* 
* This file is auto-generated by Graphweaver. 
* Please do not edit it directly.
*/
import * as Types from '../../../../../../backend/src/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SearchBagsForAuditQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.TrackableAssetsListFilter>;
}>;


export type SearchBagsForAuditQuery = { __typename?: 'Query', trackableAssets?: Array<{ __typename?: 'TrackableAsset', id: string, assetType?: Types.AssetType | null, intendedMaterial?: Types.MaterialType | null, status?: Types.AssetStatus | null, shouldConfirmMaterial: boolean } | null> | null };

export type FacilityBagAuditMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.FacilityBagAuditInput>;
}>;


export type FacilityBagAuditMutation = { __typename?: 'Mutation', facilityBagAudit?: { __typename?: 'ScanEvent', id: string } | null };

export type UploadBagAuditPhotoMutationVariables = Types.Exact<{
  input: Types.ScanEventPhotoInsertInput;
}>;


export type UploadBagAuditPhotoMutation = { __typename?: 'Mutation', createScanEventPhoto?: { __typename?: 'ScanEventPhoto', id: string } | null };


export const SearchBagsForAuditDocument = gql`
    query SearchBagsForAudit($filter: TrackableAssetsListFilter) {
  trackableAssets(filter: $filter) {
    id
    assetType
    intendedMaterial
    status
    shouldConfirmMaterial
  }
}
    `;

/**
 * __useSearchBagsForAuditQuery__
 *
 * To run a query within a React component, call `useSearchBagsForAuditQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchBagsForAuditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchBagsForAuditQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSearchBagsForAuditQuery(baseOptions?: Apollo.QueryHookOptions<SearchBagsForAuditQuery, SearchBagsForAuditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchBagsForAuditQuery, SearchBagsForAuditQueryVariables>(SearchBagsForAuditDocument, options);
      }
export function useSearchBagsForAuditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchBagsForAuditQuery, SearchBagsForAuditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchBagsForAuditQuery, SearchBagsForAuditQueryVariables>(SearchBagsForAuditDocument, options);
        }
export function useSearchBagsForAuditSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchBagsForAuditQuery, SearchBagsForAuditQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchBagsForAuditQuery, SearchBagsForAuditQueryVariables>(SearchBagsForAuditDocument, options);
        }
export type SearchBagsForAuditQueryHookResult = ReturnType<typeof useSearchBagsForAuditQuery>;
export type SearchBagsForAuditLazyQueryHookResult = ReturnType<typeof useSearchBagsForAuditLazyQuery>;
export type SearchBagsForAuditSuspenseQueryHookResult = ReturnType<typeof useSearchBagsForAuditSuspenseQuery>;
export type SearchBagsForAuditQueryResult = Apollo.QueryResult<SearchBagsForAuditQuery, SearchBagsForAuditQueryVariables>;
export const FacilityBagAuditDocument = gql`
    mutation FacilityBagAudit($input: FacilityBagAuditInput) {
  facilityBagAudit(input: $input) {
    id
  }
}
    `;
export type FacilityBagAuditMutationFn = Apollo.MutationFunction<FacilityBagAuditMutation, FacilityBagAuditMutationVariables>;

/**
 * __useFacilityBagAuditMutation__
 *
 * To run a mutation, you first call `useFacilityBagAuditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFacilityBagAuditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [facilityBagAuditMutation, { data, loading, error }] = useFacilityBagAuditMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFacilityBagAuditMutation(baseOptions?: Apollo.MutationHookOptions<FacilityBagAuditMutation, FacilityBagAuditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FacilityBagAuditMutation, FacilityBagAuditMutationVariables>(FacilityBagAuditDocument, options);
      }
export type FacilityBagAuditMutationHookResult = ReturnType<typeof useFacilityBagAuditMutation>;
export type FacilityBagAuditMutationResult = Apollo.MutationResult<FacilityBagAuditMutation>;
export type FacilityBagAuditMutationOptions = Apollo.BaseMutationOptions<FacilityBagAuditMutation, FacilityBagAuditMutationVariables>;
export const UploadBagAuditPhotoDocument = gql`
    mutation UploadBagAuditPhoto($input: ScanEventPhotoInsertInput!) {
  createScanEventPhoto(input: $input) {
    id
  }
}
    `;
export type UploadBagAuditPhotoMutationFn = Apollo.MutationFunction<UploadBagAuditPhotoMutation, UploadBagAuditPhotoMutationVariables>;

/**
 * __useUploadBagAuditPhotoMutation__
 *
 * To run a mutation, you first call `useUploadBagAuditPhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadBagAuditPhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadBagAuditPhotoMutation, { data, loading, error }] = useUploadBagAuditPhotoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadBagAuditPhotoMutation(baseOptions?: Apollo.MutationHookOptions<UploadBagAuditPhotoMutation, UploadBagAuditPhotoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadBagAuditPhotoMutation, UploadBagAuditPhotoMutationVariables>(UploadBagAuditPhotoDocument, options);
      }
export type UploadBagAuditPhotoMutationHookResult = ReturnType<typeof useUploadBagAuditPhotoMutation>;
export type UploadBagAuditPhotoMutationResult = Apollo.MutationResult<UploadBagAuditPhotoMutation>;
export type UploadBagAuditPhotoMutationOptions = Apollo.BaseMutationOptions<UploadBagAuditPhotoMutation, UploadBagAuditPhotoMutationVariables>;